import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import ContactForm from '../components/ContactForm';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #ededed;
  min-height: 100vh;
`;

const Contacts = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "Максимум Тур",
    "image": `${window.location.origin}/logo512.png`,
    "telephone": "+79964269652",
    "email": "info@maximum-tur.ru",
    "url": window.location.origin,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Алеутская улица, 45а",
      "addressLocality": "Владивосток",
      "addressRegion": "Приморский край",
      "postalCode": "690000",
      "addressCountry": "RU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "43.1155",
      "longitude": "131.8855"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "18:00"
    },
    "sameAs": [
      "https://2gis.ru/vladivostok/firm/branch/70000001083663369"
    ]
  };

  return (
    <PageContainer>
      <SEO 
        title="Контакты турагентства Максимум Тур | Адрес, Телефон во Владивостоке"
        description="Контактная информация турагентства Максимум Тур во Владивостоке. Адрес: Алеутская улица, 45а. Телефон: +7 (996) 426-96-52. Схема проезда, время работы."
        keywords="контакты, адрес, телефон, схема проезда, как добраться, офис, Максимум Тур, Владивосток"
        type="website"
        structuredData={structuredData}
      />
      <Menu />
      <Header />
      <PageHeader />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default Contacts;